import { APP_ROUTES } from "~/constants/appRoutes";

/** Session cookie set on an Oestra landing page; read by the quiz redirect and the experiment audience. */
export const LP_VISITED_COOKIE = "ib-lp-visited";

export const LP_VISITED_COOKIE_VALUE = "1";

/** Session cookie set when the quiz redirects a visitor to the LP; tells a later quiz visit whether an LP visit came after the redirect. */
export const QUIZ_LP_REDIRECTED_COOKIE = "ib-quiz-lp-redirected";

/** Where the Oestra quiz sends visitors who have not seen a landing page yet. */
export const OESTRA_QUIZ_LP_REDIRECT_URL = APP_ROUTES.TREATMENT_BIOIDENTICAL_HRT;

/** Existing LPs only: the redirect target is excluded so redirected visitors stay in the experiment audience. */
export const OESTRA_LP_PATHS: ReadonlySet<string> = new Set([
    APP_ROUTES.TREATMENT_HRT,
    APP_ROUTES.TREATMENT_HRT_3,
    APP_ROUTES.TREATMENT_PERIMENOPAUSE,
    APP_ROUTES.TREATMENT_PERIMENOPAUSE_AD,
    APP_ROUTES.TREATMENT_MENOPAUSE,
    APP_ROUTES.TREATMENT_ENDOMETRIOSIS,
    APP_ROUTES.TREATMENT_PCOS,
    APP_ROUTES.TREATMENT_POSTPARTUM,
    APP_ROUTES.TREATMENT_TESTOSTERONE,
    APP_ROUTES.MENOPAUSE_AD,
    APP_ROUTES.OESTRA_REASONS,
    APP_ROUTES.PRODUCT_PAGE,
    APP_ROUTES.PERI_LABS,
    APP_ROUTES.MENOPAUSE_WEIGHT_GAIN,
    APP_ROUTES.COMPARE_MIDI_HEALTH,
    APP_ROUTES.COMPARE_HONE_HEALTH,
    APP_ROUTES.COMPARE_ALLOY_HEALTH,
    APP_ROUTES.COMPARE_WINONA_HEALTH,
]);
